import { useGetDeviceHeartbeatCurrentValuesQuery } from "graphqlBase/Devices/__generated__/getDeviceHeartbeatCurrentValues";
import { useMemo } from "react";

const useGetHeartbeatCurrentValuesByDeviceId = () => {
  const { data } = useGetDeviceHeartbeatCurrentValuesQuery();
  const heartbeatCurrentValueByDeviceId: { [key: string]: string } = useMemo(() => {
    return (
      (data?.deviceHeartbeatCurrentValues?.items ?? [])?.reduce<{ [key: string]: string }>((acc, cur) => {
        if (!cur) return acc;
        acc[cur.deviceId] = cur.utcTimeMeasured;
        return acc;
      }, {}) ?? {}
    );
  }, [data]);
  return { heartbeatCurrentValueByDeviceId };
};

export default useGetHeartbeatCurrentValuesByDeviceId;
